import { Outlet } from "react-router-dom";
import ContentWrapper from "./ContentWrapper";
import PublicBar from "../components/PublicBar";

export default function PublicLayout() {
  return (
    <>
        <PublicBar />
        <ContentWrapper>
            <Outlet /> {/* renders child routes */}
        </ContentWrapper>
    </>
  );
}
